import { Controller } from "@hotwired/stimulus"

// Attached to individual service-board cards and KDS tickets. On connect
// (whether initial render or arriving via Turbo Stream append/replace),
// emits `ops-alerts:ping` with the card's DOM id. The ops-alerts controller
// maintains a seen-ids set and only beeps for ids it hasn't seen before —
// so replace broadcasts (state transitions, column moves) stay silent.
export default class extends Controller {
  connect() {
    window.dispatchEvent(
      new CustomEvent("ops-alerts:ping", {detail: {id: this.element.id}})
    )
  }
}
